export default __webpack_public_path__ + "static/media/download.6bce6faa.svg";